export default __webpack_public_path__ + "static/azalea-logo-h-3f08566669545b80b70e05523c6d7554.svg";